import * as React from "react";
import { SVGProps } from "react";

const MantraDao = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 405 405" {...props}>
    <circle cx={202.5} cy={202.5} r={202.5} fill="#fff" />
    <circle
      cx={202.5}
      cy={202.5}
      r={199.2}
      fill="none"
      stroke="#eb1a6b"
      strokeWidth={6.68}
    />
    <path d="M252.3 239.8c5.3 3.8 8 6.1 11 8 18.2 12.1 38 13.3 50.9 1.1 13.7-13.3 14.8-30 8.4-47.1-6.8-19.4-22.8-31.1-42.1-28.1-8.7 1.5-19 8-23.9 15.2-12.1 17.5-16.3 39.9-36.4 51.6-2.7 1.5-1.9 10.2-1.9 15.6.4 38-27.3 67.2-67.2 71-31.5 3-78.6-22.4-78.2-57.7 16.7 7.6 32.6 18.2 50.5 22 14.8 3.4 32.6 1.9 47.5-3 19.4-6.5 28.5-25.1 26.2-41.8-2.3-14.4-8-18.2-37.2-23.2-1.9-8.4-3.8-17.5-5.7-27.7 3-.4 5.3-1.1 7.6-1.1 13.3-1.1 27.7-1.5 28.8-20.1 1.1-14.8-12.9-32.3-29.2-30.7-15.9 1.5-30.7 9.9-49 16.3-3.4-5.3-9.1-14-14.4-22.8 23.2-27.3 61.1-32.6 88.8-12.5 25.4 18.2 27.7 47.5 5.3 81.6 6.5 6.1 12.9 12.1 22 20.9 3-9.1 4.6-15.6 6.8-21.6 3-8.7 5.3-18.2 10.2-26.2 12.1-20.9 28.9-35.3 55-32.3 25.4 3 38.4 18.1 48.1 41.7 10.6 27.6 6.3 48.4 0 64.2-6.3 15.8-29.5 31.9-46.2 29.2-22-3.4-34.5-17.4-35.7-42.5z" />
    <path d="M179.1 94.4c34.9 24.3 65.7 20.9 96.8-.4 5.7 9.1 10.6 16.7 15.6 24.3-36.9 28.9-96.9 14.1-112.4-23.9z" />
    <path
      fill="#f01871"
      d="M206.8 80.4c6.8-8.4 12.1-14.4 18.6-22 7.6 8 12.5 13.3 18.6 20.1-5.7 6.5-11 12.1-17.8 19.4-6.5-5.7-12.2-11.1-19.4-17.5z"
    />
  </svg>
);

export default MantraDao;
